import { render, staticRenderFns } from "./Seating_your_keybord.vue?vue&type=template&id=45905059&"
import script from "./Seating_your_keybord.vue?vue&type=script&lang=js&"
export * from "./Seating_your_keybord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports